import { useDecision } from '@optimizely/react-sdk'

export function useIngredientCustomisationsEnabled() {
  const [ingredientCustomisations] = useDecision('turnips_ofx_recipe_customisations_webclient')

  return ingredientCustomisations.variationKey === 't1'
}
